<template>
  <div>
    <h2 class="mt-6 mb-6">使用者基本資料</h2>

    <v-form v-model="valid">
      <v-card-text>
        <v-text-field v-model="tempData.email" label="帳號信箱" outlined readonly disabled></v-text-field>
        <v-text-field v-model="tempData.username" :rules="[formRules.required]" label="使用者名稱" outlined></v-text-field>
        <v-select
          v-model="tempData.role_id"
          :items="mappingRole"
          item-text="text"
          item-value="value"
          :rules="[formRules.required]"
          label="權限角色"
          placeholder="權限角色"
          outlined
        ></v-select>
        <v-select
            v-model="tempData.view_cash_transactions"
            :items="viewStatus"
            item-text="text"
            item-value="value"
            label="瀏覽現金交易"
            placeholder="瀏覽現金交易"
            outlined
            v-if="tempData.role_id == 300"
          ></v-select>
        <v-select
          v-model="tempData.status"
          :items="mappingStatus"
          item-text="text"
          item-value="value"
          :rules="[formRules.required]"
          label="帳號狀態"
          placeholder="帳號狀態"
          outlined
        ></v-select>
      </v-card-text>

      <div class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" :disabled="!valid" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更使用者基本資料？" text />
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import userApi from "@/api/user";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [DataMixin],

  props: ["id"],
  data() {
    return {
      user: {},
      tempData: {},

      dialog: false,

      valid: false
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      this.user = JSON.parse(JSON.stringify(res.user));
      this.tempData = JSON.parse(JSON.stringify(res.user));
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.user));
    },

    submit() {
      const preRoleId = this.user.role_id;

      userApi
        .updateInfo(this.id, {
          username: this.tempData.username,
          role_id: this.tempData.role_id,
          view_cash_transactions: this.tempData.view_cash_transactions,
          status: this.tempData.status
        })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
            
            this.reset();
          } else {
            this.resHandling(res);

            if (preRoleId !== res.user.role_id) {
              this.$emit("setRoleId", res.user.role_id);
            }
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    userApi
      .getInfo(this.id)
      .then(res => {
        this.resHandling(res);

        this.$emit("setRoleId", res.user.role_id);
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
